const apiEndpoints={
    LOGIN_API: '/userAuth/api/v2/userLogin',
    RESEND_OTP: '/userAuth/api/userLogin/resendOTP',
    VERIFY_OTP_API: '/userAuth/api/userLogin/v2/verifyOTP',
    LOGOUT_API: '/userAuth/api/logout',
    UPDATE_PROFILE_API: '/userAuth/api/updateUserProfile',
    VIEW_PROFILE_API: '/userAuth/api/viewProfile',
    UPDATE_MOBILE_RESEND_OTP: '/userAuth/api/updatePhoneNo/resendOTP',
    UPDATE_MOBILE_NUMBER_OTP: '/userAuth/api/updatePhoneNo',
    UPDATE_MOBILE_VERIFY_OTP: '/userAuth/api/updatePhoneNo/verifyOTP',
    FORGOT_PASSWORD_API: '/userAuth/api/forgotPasswordEmailOrPhone',
    CREATE_PASSWORD_API: '/userAuth/api/setGuestUserPassword',
    LOGIN_WITH_PASSWORD_API: '/userAuth/api/guestLoginWithPassword',

    GET_GUEST_DETAILS_API: '/wellnessGuest/api/guestDetailsById',
    UPDATE_GUEST_DOB_API: '/userAuth/api/updateDobOfUser',
    GET_GUEST_LIST_API: '/wellnessGuest/api/v2/guestList',
    GET_GUEST_NAME_LIST_API: '/wellnessGuest/api/sessions/getGuestList',
    GET_SEARCHED_GUEST_LIST_API: '/wellnessGuest/api/searchGuest',
    VIEW_GUEST_PROFILE_API: '/wellnessGuest/api/guestDetailsById',
    GET_ANANDA_PROGRAMS_LIST: '/adminPrograms/api/getAnandaProgramList',

    //prelim assessment
    GET_PRELIM_ASSESSMENT_API: '/wellness/assessment/api/getPrelimAssessmentForGuest',
    DELETE_PRELIM_ASSESSMENT_API: '/wellness/assessment/api/deletePrelimAssessment',
    ADD_PRELIM_ASSESSMENT_API: '/wellness/assessment/api/addPrelimAssessmentGuestData',
    UPDATE_PRELIM_ASSESSMENT_API: '/wellness/assessment/api/updatePrelimAssessmentGuestData',
    DOWNLOAD_PRE_ARRIVAL_CONSULTATION_PDF_API: '/wellnessGuest/api/pdf/printPreArrivalConsultation',
    GET_HEALTH_CATEGORY_LIST_API: '/wellness/assessment/api/getPacHealthCatagories',

    //wellbeing report
    VIEW_WELLBEING_REPORT_API: '/wellness/wellbeingReport/api/getWellbeingReportOfGuest', 
    WELLBEING_REPORT_VISIBLE_STATUS_API: '/wellness/wellbeingReport/api/updateWllbeingReportVisibleStatus',
    VIEW_FULL_WELLBEING_REPORT_API: '/wellness/wellbeingReport/api/viewFullAssessment', 
    GET_WELLBEING_REPORT_EDIT_DATA_API: '/wellness/wellbeingReport/api/viewFullAssessment',
    UPDATE_WELLBEING_REPORT_DATA_API: '/wellness/wellbeingReport/api/editGuestAssessment', 
    ASSESSMENT_SECTIONS_API: '/wellness/wellbeingReport/api/healthAssessmentSections', 
    REOPEN_ASSESSMENT_FOR_GUEST_API: '/wellness/wellbeingReport/api/reopenSelfAssessment',
    DOWNLOAD_WELLBEING_REPORT_PDF_API: '/wellnessGuest/api/pdf/printWellbeingReport',
    OPEN_HEALTH_ASSESSMENT_API: '/guestSelfAssessment/api/updateIsActiveStatusAssessment',

    //preparatory diet
    VIEW_PREPARATORY_DIET_API: '/wellness/preparatoryDiet/api/viewPreparatoryDiet',
    DELETE_PREPARATORY_DIET_API: '/wellness/preparatoryDiet/api/removePreparatoryDiet',
    UPDATE_PREPARATORY_DIET_API: '/wellness/preparatoryDiet/api/updatePreparatoryDiet',
    ADD_PREPARATORY_DIET_API: '/wellness/preparatoryDiet/api/cron/addPreparatorydiet',
    UPDATE_VISIBLE_STATUS_PREPARATORY_DIET_API: '/wellness/preparatoryDiet/api/updateVisibleStatus',

    //notes
    VIEW_CONSULTATION_NOTES_API: '/wellness/notes/api/v3/viewConsultationNotes',
    DELETE_CONSULTATION_NOTES_API: '/wellness/notes/api/deleteNotes',
    UPDATE_CONSULTATION_NOTES_API: '/wellness/notes/api/updateConsultationNotes',
    ADD_CONSULTATION_NOTES_API: '/wellness/notes/api/addConsultationNotes',
    UPDATE_VISIBLE_STATUS_CONSULTATION_NOTES_API: '/wellness/notes/api/updateConsultationNotesVisibleStatus',
    GET_PREVIOUS_CONSULTATION_NOTE_BY_TYPE_API: "/wellness/notes/api/getLastUpdatedNotes",
    GET_NOTES_TYPE_LIST_API: '/wellnessGuest/api/getNoticeType',
    GET_LAB_TEST_LIST_API: '/wellness/notes/api/getLabMasterData',
    DOWNLOAD_CONSULTATION_NOTES_EXCEL_API: '/wellness/notes/api/csv/downloadConsolidateNotesReportExcel',
    GET_SESSION_LIST_AGAINST_TO_NOTES_API: '/wellness/notes/api/getSessionListAgainstToNotes',
    DOWNLOAD_PENDING_NOTES_EXCEL_API: '/wellness/notes/api/cron/sendNotificationForPendingConsultationNotes',

    //sessions
    GET_DAYWISE_USER_SCHEDULE_API: '/wellness/session/api/userDayWiseSchedule',
    VIEW_SESSION_NOTES_API: '/wellness/session/api/viewSessionNotes',
    DELETE_SESSION_NOTES_API: '/wellness/session/api/removeSessionNotes',
    ADD_SESSION_NOTES_API: '/wellness/session/api/addSessionNotes',

    //query
    GET_QUERY_LIST_API: '/guestQueryChat/api/getQueryChats',
    GET_QUERY_MESSAGE_API: '/guestQueryChat/api/getChatsMessages',
    SEND_MESSAGE_IN_QUERY_API: '/guestQueryChat/api/sendMessage',
    GET_QUERY_DETAILS_API: '/guestQueryChat/api/chatDetailsByChatId',
    UPDATE_QUERY_STATUS_API: '/guestQueryChat/api/updateQueryChatStatus',

    //Group activity / classes
    GET_ACTIVITY_LIST_BY_DATE_API: '/wellnessGuest/api/getGroupActivityList',
    GET_ACTIVITY_DETAILS_API: '/adminPrograms/api/getInHouseActivityDetailsById',
    GET_INTERESTED_USER_LIST_API: '/adminPrograms/api/interestedGuestList',
    GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY_API: '/wellnessGuest/api/getActiveUsersListForGroupActivity',
    ADD_USER_TO_GROUP_ACTIVITY_API: '/wellnessGuest/api/addGuestToGroupActivity',
    REMOVE_USER_FROM_GROUP_ACTIVITY_API: '/wellnessGuest/api/removeGuestToGroupActivity',

    //status report
    GET_WELLNESS_STATUS_REPORT_API: '/wellnessGuest/api/statusReport',
    GET_STATUS_REPORT_FILTER_LIST_API: '/wellnessGuest/api/statusReportFilterList',

    //Testimonial
    GET_TESTIMONIAL_API: '/adminReportsManagement/api/getTestimonialDetail',
    GET_PROGRAMME_FEEDBACK_API: '/adminReportsManagement/api/reports/viewFeedbackDetails',

    //Help
    GET_USER_MANUALS_API: '/adminUserManagement/api/viewAnandaDocs',

    //Recommendations
    GET_THERAPIST_LIST_API: '/wellness/session/api/therapistList',
    GET_RECOMMENDATIONS_API: '/wellness/session/api/sessionList/therapist',
    DOWNLOAD_RECOMMENDATIONS_EXCEL_API: '/wellness/session/api/sessionList/csv/therapist',

    DOWNLOAD_DIETARY_REPORT_EXCEL_API: '/wellness/notes/api/csv/downloadDietaryNotesExcel',

    GET_TEAM_MEMBERS_LIST_API: '/adminUserManagement/api/getTeamMembersList',
}

export default apiEndpoints;